module.exports = __webpack_public_path__ + "img/TotalEnergies_80X30.ea7678d5.png";